export default __webpack_public_path__ + "static/media/bullet.888f352f.svg";